<template>
  <div class="asc-alert-item--container">
    <div class="asc-alert-item">
      <asc-alert-icon-label
        :status="status"
        :value="value"
        :title="title"
        :color="getBgColor1"
        :color-icon-only="colorIconOnly"
      ></asc-alert-icon-label>
    </div>
  </div>
</template>

<script>
import { AscStatusPropsMixin } from '@/components/mixins'
import AscAlertIconLabel from '@/components/atoms/AscAlertIconLabel'

export default {
  name: 'AscAlertItem',

  components: {
    AscAlertIconLabel,
  },

  mixins: [AscStatusPropsMixin],

  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      required: true,
    },
    colorIconOnly: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-alert-item--container {
  .asc-alert-item {
    margin-right: 8px;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
